'use client';

import LinkButton from '@carvana/ds-link-button';
import SectionContainer from '@/vdp/SectionContainer';
import getOutOfAreaVariant from '@/vdp/VehicleInfoCard/OutOfAreaErrorContent/getOutOfAreaVariant';
import Section from '~/constants/vdp/section';
import { useSectionAnalytics } from '~/context/vdp/SectionAnalyticsContext';
import { useSecondaryButtonHandler } from '~/hooks/vdp/cta';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import {
  Description,
  Heading,
  Wrapper
} from './ComposerAvailabilityNotice.styles';

// Composer treatment hides the blue CtaWrapper footer; this covers the remaining footer states
// (on hold, out of area) whose copy would otherwise be lost. The mini hero already surfaces
// unavailability copy separately, so that state isn't duplicated here.
function ComposerAvailabilityNoticeContent() {
  const { analyticsId } = useSectionAnalytics();
  const handleNotifyMe = useSecondaryButtonHandler();
  const { notAvailableInCA, outOfMarket, outOfMarketNewCar, purchasePending } =
    useAlertStatus();
  const outOfAreaVariant = getOutOfAreaVariant({
    notAvailableInCA,
    outOfMarket,
    outOfMarketNewCar
  });

  if (outOfAreaVariant) {
    return (
      <Wrapper>
        <Heading>{outOfAreaVariant.heading}</Heading>
        <Description>{outOfAreaVariant.description}</Description>
      </Wrapper>
    );
  }

  if (purchasePending) {
    return (
      <Wrapper>
        <Heading>A customer started purchasing this vehicle</Heading>
        <Description>
          <LinkButton
            className="!inline !p-0"
            data-adobe-id={null}
            data-analytics-attributes={JSON.stringify({
              description: 'sign up to be notified'
            })}
            data-analytics-id={analyticsId}
            data-testid="on-hold-notify-me"
            onClick={handleNotifyMe}
            size="sm"
            underline={false}
          >
            Sign up to be notified
          </LinkButton>{' '}
          when it’s available.
        </Description>
      </Wrapper>
    );
  }

  return null;
}

function ComposerAvailabilityNotice() {
  return (
    <SectionContainer section={Section.ComposerAvailabilityNotice}>
      <ComposerAvailabilityNoticeContent />
    </SectionContainer>
  );
}

export default withErrorBoundary(
  ComposerAvailabilityNotice,
  undefined,
  undefined,
  Section.ComposerAvailabilityNotice
);
